var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RateAgentFilterBox',{on:{"on-refresh":_vm.onRefresh}}),_c('div',{staticClass:"chart-content"},[_c('div',{staticClass:"bar-chart"},[_c('RateAgentTimeLine',{ref:"rate_agent_time_line"})],1),_c('div',{staticClass:"donut-chart"},[_c('RateAgentOverall',{ref:"rate_agent_overall"})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }